import { useTranslation } from 'react-i18next';
import { IP2GCoreComponentProps } from '@parcel2go/core-ui/dist/types';
import { P2GTextField } from '@parcel2go/core-ui';
import { MenuItem } from '@mui/material';
import { translatedTrackingStage } from '../utils/mapParcelStage';
import { TranslationNamespaces } from '~/lib/constants';
import { ReactNode } from 'react';

interface IDropdownOption {
  stage: string;
  text?: string;
  value: string;
}

export const DropdownOption: React.FC<IDropdownOption> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);

  const stageKey = props.stage;
  const translatedTabText = t('HISTORY_PARCEL_SELECTOR_PARCEL', 'Parcel');

  if (stageKey === 'TRACKING_STAGE_ISSUE') {
    return (
      <MenuItem key={props.value} value={props.value}>
        &#x26A0; {translatedTabText} {props.text || props.value} ({translatedTrackingStage(t, stageKey)})
      </MenuItem>
    );
  }

  if (stageKey === 'TRACKING_STAGE_NULL') {
    return (
      <MenuItem key={props.value} value={props.value}>
        {translatedTabText} {props.text || props.value}
      </MenuItem>
    );
  }

  return (
    <MenuItem key={props.value} value={props.value}>
      {translatedTabText} {props.text || props.value} ({translatedTrackingStage(t, stageKey)})
    </MenuItem>
  );
};

interface IParcelDropdownProps extends IP2GCoreComponentProps {
  onChange: (value: string) => Promise<void> | void;
  required?: boolean;
  id: string;
  label?: string;
  type?: string;
  fullWidth?: boolean;
  value: string;
  autoComplete?: string;
  helperText?: string;
  autoFocus?: boolean;
  options: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  disabled?: boolean;
}

export const ParcelDropdown: React.FC<IParcelDropdownProps> = (props) => {
  return (
    <P2GTextField
      id={props.id}
      label={props.label || props.id}
      type={props.type || 'text'}
      fullWidth={props.fullWidth || true}
      required={props.required}
      value={props.value}
      onChange={(e) => props.onChange(e.currentTarget.value)}
      autoComplete={props.autoComplete}
      helperText={props.helperText}
      autoFocus={props.autoFocus}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.options}
    </P2GTextField>
  );
};
